import { render, staticRenderFns } from "./Vmc.vue?vue&type=template&id=4b9887e7&scoped=true"
import script from "./Vmc.vue?vue&type=script&lang=js"
export * from "./Vmc.vue?vue&type=script&lang=js"
import style0 from "./Vmc.vue?vue&type=style&index=0&id=4b9887e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9887e7",
  null
  
)

export default component.exports